(() => {
  // Désactiver dans l'éditeur Shopify
  if (window.Shopify && window.Shopify.designMode) return;

  // Respecter "Réduire les animations"
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.addEventListener('DOMContentLoaded', () => {
    if (!window.gsap || !window.ScrollTrigger) {
      console.warn('GSAP ou ScrollTrigger n’a pas été chargé.');
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    // Synchroniser ScrollTrigger avec Lenis
    if (window.fullstackLenis) {
      window.fullstackLenis.on('scroll', ScrollTrigger.update);
    }

    const elements = document.querySelectorAll(
      '[data-securishome-reveal]'
    );

    elements.forEach((element) => {
      gsap.set(element, {
        autoAlpha: 0,
        y: 24
      });

      gsap.to(element, {
        autoAlpha: 1,
        y: 0,
        duration: 0.8,
        ease: 'power2.out',

        scrollTrigger: {
          trigger: element,
          start: 'top 82%',
          once: true
        }
      });
    });
  });
})();